import React from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../store/Reduxstore";

const Wrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rolesList = useSelector((state: RootState) => state.auth);

  React.useEffect(() => {
    if (location.pathname === "/erp") {
      navigate("pages/assetInventory"); // Optional: you can default to this
    }
  }, [location.pathname, rolesList.role]);

  React.useEffect(() => {
    if (location.pathname === "/erp") {
      navigate("pages");
    }
  }, [location.pathname,rolesList.role]);

  return <div><Outlet/></div>;
};

export default Wrapper;
